import bodymovin from 'lottie-web-light';

window.animations = [];

function animate_eye(){

    var eyes = document.querySelectorAll('#eye');

    for (let a = 0; a < eyes.length; a++) {
        
        if(!eyes[a].classList.contains('bound')){

            eyes[a].classList.add('bound');

            var animation = bodymovin.loadAnimation({
                container: eyes[a], // Required
                path: '/assets/data/eye.json', // Required
                renderer: 'svg', // Required
                loop: false, // Optional
                autoplay: false, // Optional
                name: "Hello World"
            })

            let frames = 0;
            

            window.animations.push(animation);
            
            animation.setSpeed(6);
            animation.playSegments([13, 25], true);
            

            animation.addEventListener("ready", () => {
                // console.log(animation);
            });

            animation.addEventListener("complete", () => {
                // animation.stop();
            });


            // eyes[a].addEventListener('click', function(e){
            //     e.preventDefault();
            //     animation.goToAndStop(0,true);
            //     animation.play();
            // });
        
        }
    
    }


}

export default animate_eye;
